import { EditDialogHeaderButtons, Icon, Stack, Tooltip, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { WorkType } from "@tm/models"
import { BasketWork } from "../../../../../../models"

type Props = {
    isSaving?: boolean
    work?: BasketWork
    onCloseButtonClick(): void
}

export function EditDialogHeader({ isSaving, work, onCloseButtonClick }: Props) {
    const { workItem } = work || {}
    const { translateText } = useLocalization()

    let title = workItem?.providerName ?? translateText(13960)
    let icon = "repairtimes"
    let iconTooltip = translateText(83)
    switch (workItem?.type) {
        case WorkType.CustomWork: {
            title = translateText(920)
            icon = "individual-repairtimes"
            iconTooltip = translateText(920)
            break
        }
        case WorkType.CustomMainWork: {
            icon = "repairtime-modified"
            iconTooltip = translateText(1473)
            break
        }
        default:
            break
    }

    return (
        <Stack direction="row" justifyContent="space-between" alignItems="start">
            <Stack direction="row" gap={1} alignContent="center" alignItems="center">
                {icon && (
                    <Tooltip title={iconTooltip || ""} variant="light">
                        <Icon name={icon} size="large" />
                    </Tooltip>
                )}
                <Typography variant="h2">{title}</Typography>
                {workItem?.type === WorkType.CustomWork && (
                    <Tooltip title={translateText(13909)} placement="right">
                        <Icon name="info" />
                    </Tooltip>
                )}
            </Stack>
            <EditDialogHeaderButtons isSaving={isSaving} onCloseButtonClick={onCloseButtonClick} />
        </Stack>
    )
}
